import "../stylesheets/App.css";
import "../stylesheets/QRGenerator.css";
import React, { useEffect } from "react";
import { QRCodeCanvas } from "qrcode.react";
import Header from "./subcomponents/Header.js";

function QRGenerator() {
  useEffect(() => {
    const el = document.getElementById("search-container");
    if (el) el.style.display = "none";
  }, []);

  return (
    <>
      <Header />
      <div className="qr-generator-container section-70">
        <h1 className="qr-generator-title qr-generator-internos-title">
          QR de acceso
        </h1>

        <div className="qr-generator-internos">
          <QRCodeCanvas
            id="qrCodeInternos"
            value="https://decimomundialista.decimodevsite.com/Internos"
            size={500}
            bgColor="#FFF"
            level="H"
          />
        </div>
      </div>
    </>
  );
}

export default QRGenerator;
